import React, { useState } from "react";
import { Heading } from "../text";
import { Icon } from "../icon";
import * as styles from "./accordion.module.scss";

export interface AccordionItem {
  id: string;
  title: string;
  content: React.ReactNode;
  expanded?: boolean;
}

export interface AccordionProps {
  items: AccordionItem[];
}

export const Accordion: React.FC<AccordionProps> = ({ items }) => {
  const [expandedIds, setExpandedIds] = useState<Set<string>>(
    () => new Set(items.filter((item) => item.expanded).map((item) => item.id))
  );

  const toggle = (id: string) => {
    setExpandedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  return (
    <div className={styles.accordion}>
      {items.map((item) => {
        const isExpanded = expandedIds.has(item.id);
        return (
          <div key={item.id} className={styles.item}>
            <button type="button" className={styles.header} onClick={() => toggle(item.id)} aria-expanded={isExpanded}>
              <Heading kind="quarternary" as="span">
                {item.title}
              </Heading>
              <Icon name={isExpanded ? "angleUp" : "angleDown"} size="s" />
            </button>
            <div className={`${styles.content}${isExpanded ? ` ${styles.expanded}` : ""}`}>
              <div>
                <div className={styles.contentBody}>{item.content}</div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
